"use client";

import getSeasonsLastEpisode from "@/tools/getSeasonsLastEpisode";
import { IMetadata } from "@/zodTypes";
import { SkipNext, SkipPrevious } from "@mui/icons-material";
import { ToggleButton, Tooltip } from "@vidstack/react";
import { useRouter } from "next/navigation";

interface IProps {
  episode: IMetadata;
}

export const PreviousEpisode: React.FC<IProps> = ({ episode }) => {
  const router = useRouter();

  const handleClick = async () => {
    if (episode.episode === 1 && episode.season !== 0) {
      const lastEpisode = await getSeasonsLastEpisode(episode.season - 1);
      console.log(lastEpisode);
      return router.push(
        `/watch/s${(episode.season - 1).toString().padStart(2, "0")}.e${lastEpisode.toString().padStart(3, "0")}`
      );
    }

    return router.push(
      `/watch/s${episode.season.toString().padStart(2, "0")}.e${(episode.episode - 1).toString().padStart(3, "0")}`
    );
  };

  if (episode.season === 0 && episode.episode === 1) {
    return <></>;
  }

  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <ToggleButton onClick={handleClick} onTouchEnd={handleClick} className="vds-button vds-play-button">
          <SkipPrevious className="vds-icon" />
        </ToggleButton>
      </Tooltip.Trigger>
      <Tooltip.Content className="vds-tooltip-content" placement="top start">
        Previous Episode
      </Tooltip.Content>
    </Tooltip.Root>
  );
};

export const NextEpisode: React.FC<IProps> = ({ episode }) => {
  const router = useRouter();

  const handleClick = async () => {
    if (episode.isLast) {
      if (episode.season === 0) {
        return router.push(`/watch/s01.e001`);
      }

      return;
    }

    return router.push(
      `/watch/s${episode.season.toString().padStart(2, "0")}.e${(episode.episode + 1).toString().padStart(3, "0")}`
    );
  };

  if (episode.isLast && episode.season === 1) {
    return <></>;
  }

  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <ToggleButton onClick={handleClick} onTouchEnd={handleClick} className="vds-button vds-play-button">
          <SkipNext className="vds-icon" />
        </ToggleButton>
      </Tooltip.Trigger>
      <Tooltip.Content className="vds-tooltip-content" placement="top center">
        Next Episode
      </Tooltip.Content>
    </Tooltip.Root>
  );
};
